import { render, staticRenderFns } from "./memberConsumeRecordList.vue?vue&type=template&id=3222d845&"
import script from "./memberConsumeRecordList.vue?vue&type=script&lang=js&"
export * from "./memberConsumeRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports